// extracted by mini-css-extract-plugin
export default {"StudentSelects":"StudentSelects_StudentSelects__1vLqL","faculty":"StudentSelects_faculty__atHQD","input":"StudentSelects_input__NTyyV"};